import { useEffect, useState } from "react";

const navItems = [
  { label: "今日头条", href: "#headlines" },
  { label: "最新更新", href: "#updates" },
  { label: "新料专题", href: "#topics" },
  { label: "今日热搜", href: "#trending" },
  { label: "信任与问答", href: "#faq" },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors duration-300 ${
        scrolled
          ? "border-background-200 bg-background-50/95 backdrop-blur"
          : "border-transparent bg-background-50"
      }`}
    >
      <div className="flex h-16 w-full items-center gap-6 px-4 md:h-20 md:px-8 lg:px-12">
        <a href="#top" className="flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-xl text-background-50 md:h-11 md:w-11">
            <i className="ri-flashlight-fill" />
          </span>
          <span className="flex flex-col leading-tight">
            <h1 className="font-heading text-lg font-bold tracking-tight text-foreground-950 md:text-xl">
              黑料网1
            </h1>
            <span className="hidden font-label text-[11px] tracking-[0.28em] text-foreground-500 sm:block">
              今日更新 · 实时滚动
            </span>
          </span>
        </a>

        <nav className="hidden flex-1 items-center justify-center gap-1 lg:flex">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="cursor-pointer whitespace-nowrap rounded-md px-4 py-2 font-label text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="ml-auto flex items-center gap-2">
          <span className="hidden items-center gap-2 rounded-full border border-background-200 bg-background-100 px-3 py-1.5 font-label text-xs text-foreground-600 xl:flex">
            <i className="ri-time-line text-accent-600" />
            刚刚更新 · 09.12
          </span>
          <a
            href="#updates"
            className="hidden cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-4 py-2.5 font-label text-sm text-background-50 transition-colors hover:bg-primary-600 sm:flex"
          >
            <i className="ri-download-2-line" />
            蹲最新
          </a>
          <button
            type="button"
            aria-label="打开导航菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-200 text-xl text-foreground-800 lg:hidden"
          >
            <i className={menuOpen ? "ri-close-line" : "ri-menu-line"} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-3 lg:hidden">
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMenuOpen(false)}
                className="cursor-pointer border-b border-background-100 py-3 font-label text-sm text-foreground-700"
              >
                {item.label}
              </a>
            ))}
          </nav>
          <a
            href="#updates"
            onClick={() => setMenuOpen(false)}
            className="mt-4 flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 font-label text-sm text-background-50"
          >
            <i className="ri-download-2-line" />
            蹲最新内容
          </a>
        </div>
      )}
    </header>
  );
}